class LoadMoreButton extends HTMLElement {
  connectedCallback() {
    this.onClickHandler = this.onClick.bind(this);
    this.addEventListener('click', this.onClickHandler);

    // Keep keyboard accessible since it's no longer a native button
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.onClickHandler();
      }
    });

    if (this.getAttribute('type') === 'infinite') {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.onClickHandler();
        },
        { rootMargin: '200px' }
      );
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
    if (this.observer) this.observer.disconnect();
  }

  onClick() {
    if (this.classList.contains('loading')) return;
    this.classList.add('loading');
    fetch(this.buildUrl())
      .then((r) => r.text())
      .then((html) => {
        this.renderProducts(html);
        this.updatePagination(html);   // <-- renamed & changed
        this.classList.remove('loading');
      });
  }

  buildUrl() {
    const url = new URL(this.getAttribute('action'), window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    return url.toString();
  }

  renderProducts(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelectorAll('ul.product-grid > li');
    const grid = document.querySelector('ul#product-grid');
    if (grid) {
      let counter = 0;

      incoming.forEach((item) => {
        if (item.hasAttribute('id')) return; // skip items with an id

        const previous_style = item.getAttribute('style');

        const newOrder = counter % 4; // cycles 1, 2, 3, 4, 1, 2, 3, 4...
        counter++;

        // Strip out --grid-order and --animation-order, then set the new animation-order
        const cleaned_style = (previous_style || '')
          .replace(/--animation-order:\s*\d+;?\s*/g, '')
          .replace(/--grid-order:\s*\d+;?\s*/g, '')
          .trim();

        const updated_style = `--animation-order: ${newOrder}; ${cleaned_style}`.trim();

        item.setAttribute('style', updated_style);
      });

      incoming.forEach((item) => grid.appendChild(item))
    };
  }

  updatePagination(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    // Look for a next load-more button in the freshly fetched page
    const nextButton = parsed.querySelector('load-more-button');

    if (nextButton) {
      // Advance this button to point at the next page
      this.setAttribute('action', nextButton.getAttribute('action'));
    } else {
      // No more pages — disable or remove the button
      if (this.observer) this.observer.disconnect();
      this.closest('.center')?.remove() ?? this.remove();
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);
